import Entity from './Entity'

export default class Recipient extends Entity {
  email
  firstName
  lastName
}
